import React from 'react';
import { GoogleIcon, MetaIcon } from './icons';

const ICON_SIZE = 20;

/**
 * Normalizes platform names from API (plataformas_relacionadas) to a list of strings.
 */
const normalizePlatforms = (plataformas) => {
  const arr = Array.isArray(plataformas) ? plataformas : (plataformas ? [plataformas] : []);
  return arr.map((p) => String(p || '').toLowerCase());
};

/**
 * Renders Google and/or Meta icons based on platform names (e.g. from objetivo.plataformas_relacionadas).
 */
const PlatformLogo = ({ plataformas, size = ICON_SIZE }) => {
  const normalized = normalizePlatforms(plataformas);
  const hasGoogle = normalized.some((p) => p.includes('google'));
  const hasMeta = normalized.some((p) => p.includes('meta') || p.includes('facebook') || p.includes('instagram') || p === 'meta ads');

  return (
    <div className="flex items-center gap-1 shrink-0" aria-hidden>
      {hasGoogle && <GoogleIcon width={size} height={size} />}
      {hasMeta && <MetaIcon width={size} height={size} />}
      {!hasGoogle && !hasMeta && <span className="w-5 text-[10px] text-white/50">-</span>}
    </div>
  );
};

export default PlatformLogo;
